import * as DateF from 'date-fns'
import styled from 'styled-components'

import { Numeric } from '@blade/ui-kit'
import { DATE_FORMAT } from '@root/shared'

import type { LeaderboardTableEntry } from '@root/features/leaderboard/model'
import type { Column } from '@root/shared/ui-kit'

export const leaderboardTableColumns: Array<Column<LeaderboardTableEntry>> = [
  {
    id: 'index' as const,
    header: () => '#',
    render: ({ value }) => (
      <Index>{value.rank.toString().padStart(2, '0')}</Index>
    ),
    width: 26,
  },
  {
    id: 'username' as const,
    header: ({ t }) => t('auth.username'),
    render: ({ value }) => <PrimaryCell>{value.name}</PrimaryCell>,
    minWidth: 100,
  },
  {
    id: 'date' as const,
    header: ({ t }) => t('common.date'),
    render: ({ value }) => (
      <DateCell>{DateF.format(value.date, DATE_FORMAT.dd_MM_yy)}</DateCell>
    ),
    minWidth: 100,
    justify: 'center',
  },
  {
    id: 'profit' as const,
    header: ({ t }) => t('common.profit'),
    render: ({ value }) => (
      <PrimaryCell>
        <Numeric
          value={value.amount}
          currency={value.currencyTicker}
          preset="currency-amount-short"
        />
      </PrimaryCell>
    ),
    minWidth: 100,
    justify: 'end',
  },
]

const Index = styled.div`
  color: var(--textA-7);

  font-size: 11px;
  font-weight: 600;
  line-height: 16px;
`

const PrimaryCell = styled.div`
  color: var(--text-12);

  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`

const DateCell = styled.div`
  color: var(--text-9);

  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`
